import React, { useContext, useEffect, useState } from "react";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import { useTranslation } from "react-i18next";
import QCModalHeader from "../../../../components/Modal/QCModalHeader";
import QCModalFooter from "../../../../components/Modal/QCModalFooter";
import themeContext from "../../../../context/theme/ThemeContext";

const QCPassConfirmModal = (props) => {
  const { getAlterColor, getThemeColor} = useContext(themeContext);
  const { t } = useTranslation();
  const {
    openQCPassConfirmModal,
    setOpenQCPassConfirmModal,
    setIsKeyImagesPresent,
    setIsTextAnnotationPresent,
    isKeyImagesPresent,
    isTextAnnotationPresent,
    handleQcPass,
    studyParentId
  } = useContext(studyReportContext);

  const handleCancel = () => {
    setOpenQCPassConfirmModal(false);
    setIsKeyImagesPresent(false);
    setIsTextAnnotationPresent(false);
  };

  const [message, setMessage] = useState("");

  useEffect(() => {
    console.log(isKeyImagesPresent)
    console.log(isTextAnnotationPresent)
    if (isKeyImagesPresent && isTextAnnotationPresent) {
      setMessage(t("QC.qc-pass-keyimage-textannotation"));
      return;
    }
    if (isKeyImagesPresent && !isTextAnnotationPresent) {
      setMessage(t("QC.qc-pass-keyimage"));
      return;
    }

    if (isTextAnnotationPresent && !isKeyImagesPresent) {
      setMessage(t("QC.qc-pass-textannotation"));
      return;
    }
  }, [isKeyImagesPresent, isTextAnnotationPresent]);

  const PrimaryButtonList = [
    {
      title: t("QC.yes"),
      onclick: () => {
        handleQcPass(
          studyParentId,
          props.keyImages,
          props.qcData,
          props.allTextToolAnnotation,
          false
        );
        setOpenQCPassConfirmModal(false);
      },
    },
  ];

  const DefaultButtonList = [
    {
      title: t("QC.no"),
      onclick: () => handleCancel(),
    },
  ];

  return (
    <div
      style={{
        height: "60%",
        width: "60%",
      }}
    >
      <QCModalHeader
        heading={t("QC.qc-pass-confirm")}
        handleCancel={handleCancel}
      />
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          // backgroundColor: "#000000",
          // color: "#FFFFFF",
          background: getThemeColor("modal-body"),
          color: getAlterColor("#FFF","#000"),
          height: "100px",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        {message}
      </div>
      <QCModalFooter
        PrimaryButtonList={PrimaryButtonList}
        DefaultButtonList={DefaultButtonList}
      />
    </div>
  );
};

export default QCPassConfirmModal;
